import script from "./AdministratorTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdministratorTable.vue?vue&type=script&lang=ts&setup=true"

import "./AdministratorTable.vue?vue&type=style&index=0&id=2c38cfc3&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ljy\\Desktop\\workspace\\JIN-SOLUTIONS\\JMON_MES\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c38cfc3"]])

export default __exports__